export const START_PALETTE = 'START_PALETTE';
export const LOAD_JOB_PALETTES_TO_START = 'LOAD_JOB_PALETTES_TO_START';
export const LOAD_COATING_IN = 'LOAD_COATING_IN';
export const SET_EMPTY_START_PALETTE = 'SET_EMPTY_START_PALETTE';
